import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/_authenticated/$slug/fleet/$aircraftId/overview/recent-activity",
)({
  staticData: {
    title: "Recent Activity",
    breadcrumbs: [{ title: "Overview", to: "/$slug/fleet/$aircraftId/overview" }],
  },
  component: lazyRouteComponent(
    () => import("#pages/authenticated/fleet/[aircraftId]/overview/recent-activity.tsx"),
    "RecentActivities",
  ),
})
